import {
  NodeColumns,
  TableRow,
  convertTextToColumnValue,
} from '../../../stores/table-store';
import { getJsonOrderMap } from '../utils';

// PSTUDIO-3729: array-valued columns whose committed value is an array split
// from the raw text on the SAME canonical converter the grid commit path uses.
export const ARRAY_COLUMNS: NodeColumns[] = [
  NodeColumns.whatsNext,
  NodeColumns.variables,
  NodeColumns.output,
  NodeColumns.nextNodes,
];

// PSTUDIO-3882: while the user is TYPING in the panel editor, write the RAW
// string (exactly like the inline grid cell's handleChange) — do NOT canonical-
// ize array columns per keystroke. Canonicalizing on every keystroke split a
// trailing `|` (the array separator) out of `whatsNext` immediately, so `|`
// could never be typed in the Expanded Cell View. JSON columns still carry
// their order-map sibling so ordering is preserved live.
export const buildPanelCellDraftUpdate = (
  columnId: string,
  raw: string,
  isJsonColumn: boolean
): Partial<TableRow> => {
  const valueMap = isJsonColumn
    ? getJsonOrderMap({ value: raw, columnId })
    : null;
  return {
    [columnId]: raw,
    ...(valueMap ? { [`${columnId}Map`]: valueMap } : {}),
  } as Partial<TableRow>;
};

// PSTUDIO-3729 + 3882: at COMMIT (blur) canonicalize the raw draft to the
// column's stored value — array columns go through `convertTextToColumnValue`
// (empty → column default `[]`, never `[0]`); JSON columns keep the raw string
// + order map; everything else stays raw.
export const buildPanelCellCommitUpdate = (
  columnId: string,
  raw: string,
  isJsonColumn: boolean
): Partial<TableRow> => {
  const valToUpdate = ARRAY_COLUMNS.includes(columnId as NodeColumns)
    ? convertTextToColumnValue(raw, columnId as keyof TableRow)
    : raw;
  const valueMap = isJsonColumn
    ? getJsonOrderMap({ value: raw, columnId })
    : null;
  return {
    [columnId]: valToUpdate,
    ...(valueMap ? { [`${columnId}Map`]: valueMap } : {}),
  } as Partial<TableRow>;
};
